import * as React from 'react';
import PropTypes from 'prop-types';

const SensorViewContext = React.createContext({
  showAllAsPlots: false,
  setShowAllAsPlots: () => {},
});

export function SensorViewProvider({ children }) {
  const [showAllAsPlots, setShowAllAsPlots] = React.useState(false);

  const value = React.useMemo(() => ({
    showAllAsPlots,
    setShowAllAsPlots,
  }), [showAllAsPlots]);

  return (
    <SensorViewContext.Provider value={value}>
      {children}
    </SensorViewContext.Provider>
  );
}

SensorViewProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useSensorView() {
  const context = React.useContext(SensorViewContext);
  if (!context) {
    throw new Error('useSensorView must be used within a SensorViewProvider');
  }
  return context;
}

export default SensorViewContext;
